import HeadNav from "../../components/HeadNav";
import {cutPhone, cutPhone1, showTotalData, fmDate, encrypt, LZStringCompress} from "../../tools";
import TabBar from "../../components/TabBar"
import ListEmpty from "../../components/ListEmpty";
import {fetchPost,fetchGet,fetchGetNews,fetchPostNews} from "../../tools/https"
import {
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub,
  substringStr,
  substringStr1
} from "../../tools/indexFun";
import localStore from '../../tools/localstorage'
export default {
  name: "Twitter",
  components: {
    HeadNav,
    TabBar,
    ListEmpty
  },
  data() {
    return {
      messages: [],
      value: null,
    }

  },
  created() {
  },
  methods: {
    BigNumberStr(num1,num2,col){
      return BigNumberStr(num1,num2,col);
    },
    substringStr(str = "", chars = 3){
      return substringStr(str, chars)
    },
    substringStr1(str = "", chars = 10){
      return substringStr1(str, chars)
    },
    async getDepositLog() {
      fetchGetNews('list',{page:1,size:20}).then((data)=>{
        // console.log('data',data)
        this.messages = data?.data?.list
      })
    },
    async refresh() {
      this.getDepositLog();
    },
  },
  mounted() {
    this.refresh();
  }
}
